__webpack_require__.p = "/wp-content/themes/recorder/js/contract-sponsorizare/";